import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { BudgetPhases } from 'business/constants';
import { InscriptionWithMetadata } from 'routes/BudgetModule/config/types';
import {
    getStatusesValuesForPhase,
    isStatusVoted,
} from 'routes/BudgetModule/helpers/statusHelpers';
import { StatusSettingsContext } from 'routes/BudgetModule/components/BudgetWithProvider/StatusSettingsContext';
import StatusOptions from './StatusOptions';
import { InscriptionQueryKey } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';

const StyStatusHeader = styled(Box, {
    name: 'StyStatusHeader',
})(({ theme }) => ({
    display: 'flex',
    padding: '0.5rem 2rem 0.5rem 2rem',
    borderColor: '#e2e2e2',
    borderWidth: '1px',
    borderBottomStyle: 'solid',
    flexDirection: 'column',
    height: '13rem',
    [theme.breakpoints.up('md')]: {
        height: '7rem',
        flexDirection: 'row',
    },
    justifyContent: 'space-between',
}));

const StyTextDivLeft = styled(Box, {
    name: 'StyTextDivCenter',
})(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        width: '20%',
    },
}));

const StyTextDivCenter = styled(Box, {
    name: 'StyTextDivCenter',
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
});

type Props = {
    selectedInscriptions: InscriptionWithMetadata[];
    inscriptions: InscriptionWithMetadata[];
    phase: BudgetPhases | null;
    queryCacheKey: InscriptionQueryKey;
    gridApi: FlowAnyObject;
};

export default function StatusHeader({
    selectedInscriptions,
    inscriptions,
    phase,
    queryCacheKey,
    gridApi,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const statusesSettings = useContext(StatusSettingsContext);

    const statuses = phase
        ? getStatusesValuesForPhase(phase, statusesSettings).filter(
              (status) => !isStatusVoted(status, statusesSettings),
          )
        : [];

    const selectedInscriptionsAreNotFromSamePhase =
        !phase && selectedInscriptions.length > 0;

    const StatusWrapper = selectedInscriptionsAreNotFromSamePhase
        ? StyTextDivCenter
        : StyTextDivLeft;

    return (
        <StyStatusHeader>
            <StatusWrapper>
                <p>
                    {selectedInscriptionsAreNotFromSamePhase
                        ? t('budgetProposal.inscriptionsNotFromSamePhase')
                        : t('budgetProposal.thereIsNInscriptions', {
                              count: selectedInscriptions.length,
                          })}
                </p>
                {statuses.length > 0 && (
                    <p>{t('budgetProposal.chooseTheStatus')}</p>
                )}
            </StatusWrapper>
            {statuses.length > 0 && phase !== null && (
                <StatusOptions
                    selectedInscriptions={selectedInscriptions}
                    inscriptions={inscriptions}
                    phase={phase}
                    queryCacheKey={queryCacheKey}
                    gridApi={gridApi}
                />
            )}
        </StyStatusHeader>
    );
}
